import { IFormTabRendering } from './prepare-for-rendering';

export function createFormGroupConfigFromRenderingTabs(tabs: IFormTabRendering[]) {
  const keys = tabs.reduce((acc, tab) => {
    return [...acc, ...extractKeysFromFields(tab.fields)];
  }, []);

  return keys.reduce((acc, {key}) => {
    return {...acc, [key]: [null]};
  }, {});
}

export function extractKeysFromFields(fields): {key: string, validators: any}[] {
  return fields.reduce((acc, field) => {
    if (field.fieldGroup) {
      return [...acc, ...extractKeysFromFields(field.fieldGroup)];
    }

    if (field.key) {
      return [...acc, {key: field.key}];
    }

    return acc;
  }, []);
}
